import './melons/style';
import FormStructure from './melons/form_structure';

export default FormStructure;